/**
 * @generated SignedSource<<c8615fe48dcc043d1ab0be9d29dd7b1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
export type StatusChoices = "busy" | "cancelled" | "confirmed" | "free" | "needsAction" | "oof" | "tentative" | "unknown" | "workingElsewhere";
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
import { FragmentRefs } from "relay-runtime";
export type RecordIcon_event$data = {
  readonly calendar: {
    readonly id: string;
  };
  readonly conferenceCalls: ReadonlyArray<{
    readonly provider: ConferenceCallProvider;
    readonly url: string;
  }>;
  readonly guid: string;
  readonly id: string;
  readonly isAllDay: boolean;
  readonly start: string | null;
  readonly status: StatusChoices;
  readonly timeBlockType: string | null;
  readonly willBeRecorded: WillBeRecordedType;
  readonly " $fragmentType": "RecordIcon_event";
};
export type RecordIcon_event$key = {
  readonly " $data"?: RecordIcon_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecordIcon_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecordIcon_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "guid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "willBeRecorded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAllDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeBlockType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConferenceCall",
      "kind": "LinkedField",
      "name": "conferenceCalls",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "provider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Calendar",
      "kind": "LinkedField",
      "name": "calendar",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "2b8c66b7b23293201b6608e571921910";

export default node;
